var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M757.435-200.514H303.078q-25.789 0-44.176-18.388-18.388-18.387-18.388-44.176v-574.357q0-25.788 18.388-44.176 18.387-18.388 44.176-18.388h310.718l206.203 206.203v430.718q0 25.789-18.388 44.176-18.388 18.388-44.176 18.388ZM588.668-670.822v-178.922h-285.59q-4.616 0-8.462 3.847-3.847 3.846-3.847 8.462v574.357q0 4.616 3.847 8.462 3.846 3.847 8.462 3.847h454.357q4.616 0 8.462-3.847 3.847-3.846 3.847-8.462v-407.744H588.668ZM162.565-60.002q-25.788 0-44.176-18.387-18.388-18.388-18.388-44.176v-556.511h50.255v556.511q0 4.616 3.847 8.462 3.846 3.847 8.462 3.847h435.844v50.255H162.565Zm128.204-789.742v178.922-178.922 598.975V-849.744Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.9cff91ae103a309c867d990bf0587460.svg";
export { ForwardRef as ReactComponent };